<template>
    <v-row dense wrap class="pa-5">
        <v-col cols="6" >
            <v-card  elevation="1" flat>
                <v-card-title style="font-size:1rem">
                    اطلاعات هویتی کاربر
                </v-card-title>
                <v-card-text>
                    <v-row wrap>
                        <v-col cols="3">نام</v-col>
                        <v-col cols="3">{{Model.u_Name}}</v-col>
                        <v-col cols="3">نام خانوادگی</v-col>
                        <v-col cols="3">{{Model.u_Family}}</v-col>
                        <v-col cols="3">پست الکترونیکی</v-col>
                        <v-col cols="3">{{Model.u_Email}}</v-col>
                        <v-col cols="3">تلفن همراه</v-col>
                        <v-col cols="3">{{Model.u_Phone}}</v-col>
                        <v-col cols="3">تلفن ثابت </v-col>
                        <v-col cols="3">{{Model.u_HomeTel}}</v-col>
                        <v-col cols="3">کدملی </v-col>
                        <v-col cols="3">{{Model.u_IdentityCode}}</v-col>
                        <v-col cols="3">تاریخ تولد </v-col>
                        <v-col cols="3">{{Model.u_BirthDate}}</v-col>
                        <v-col cols="12">مدارک ارسالی کاربر</v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="6">
                <v-card elevation="1" flat>
                    <v-card-title style="font-size:1rem">آدرس های ثبت شده</v-card-title>
                    <v-card-text>
                        <v-row wrap>
                            <v-col cols="4" class="mr-1" style="border:.1rem solid #eee;border-radius: 0.5rem;"  v-for="(i,index) in Model.addresses" :key="index">
                                <p>استان : {{i.province.name}} </p>
                                <p>شهرستان : {{i.state.name}}</p>
                                <p>آدرس : {{i.a_Address}}</p>
                                <p>دریافت کننده : {{i.a_ReciverName }} - {{i.a_ReciverTel}}</p>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
        </v-col>
        <v-col cols="6">
                <v-card elevation="1" flat>
                    <v-card-title style="font-size:1rem">کیف پول</v-card-title>
                    <v-card-text>
                        <div class="pa-2"><i>موجودی کیف پول مشتری : </i><b>{{Model.wallet}}</b></div>
                        <v-simple-table dir="rtl">
                            <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center">
                                        مبلغ (تومان)
                                    </th>
                                    <th class="text-center">
                                        نوع عملیات
                                    </th>
                                    <th class="text-center">
                                        تاریخ
                                    </th>
                                    <th class="text-center">
                                        توضیحات
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                v-for="item in filterWalletHistory(Model.walletHistories)"
                                :key="item" 
                                >
                                <td class="text-center">{{item.amount}}</td>
                                <td class="text-center">
                                    <v-chip small dark :color="item.wH_TransactionType == 1 ? 'green':'red'">{{ item.transactionType }}</v-chip>
                                </td>
                                <td class="text-center">{{ item.date }}</td>
                                <td class="text-center">{{ item.wH_Description }}</td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
        </v-col>
        <v-col cols="6">
            <v-card elevation="1" flat>
                    <v-card-title style="font-size:1rem">سوابق برداشت نقدی از کیف پول</v-card-title>
                    <v-card-text>
                        <v-simple-table dir="rtl">
                            <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center">
                                        مبلغ (تومان)
                                    </th>
                                    <th class="text-center">
                                     هزینه انتقال وجه
                                    </th>
                                    <th class="text-center">
                                     شماره کارت
                                    </th>
                                    <th class="text-center">
                                     وضعیت
                                    </th>
                                    <th class="text-center">
                                        تاریخ
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                v-for="item in Model.cashRequests"
                                :key="item" 
                                >
                                <td class="text-center">{{item.amount}}</td>
                                <td class="text-center">{{item.c_TransferWage}}</td>
                                <td class="text-center">{{item.creditCard.c_Number}}({{item.creditCard.c_Title}})</td>
                                
                                <td class="text-center">

                                    <v-chip small v-if="item.c_Status == 0" dark color="orange">در حال بررسی</v-chip>
                                    <v-chip small v-if="item.c_Status == 1" dark color="green">تایید شد</v-chip>
                                    <v-chip small v-if="item.c_Status == 2" dark color="red">رد شد</v-chip>
                                </td>
                                <td class="text-center">{{ item.date }}</td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="6">
                <v-card elevation="1" flat>
                    <v-card-title style="font-size:1rem">کیف طلا</v-card-title>
                    <v-card-text>
                        <div class="pa-2"><i>موجودی کیف طلا مشتری : </i><b>{{Model.goldWallet}}</b></div>
                        <v-simple-table dir="rtl">
                            <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center">
                                        مقدار (گرم)
                                    </th>
                                    <th class="text-center">
                                        نوع عملیات
                                    </th>
                                    <th class="text-center">
                                        تاریخ
                                    </th>
                                    <th class="text-center">
                                        توضیحات
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                v-for="item in filterWalletHistory(Model.walletHistories,1)"
                                :key="item" 
                                >
                                <td class="text-center">{{item.amount}}</td>
                                <td class="text-center">
                                    <v-chip small dark :color="item.wH_TransactionType == 1 ? 'green':'red'">{{ item.transactionType }}</v-chip>
                                </td>
                                <td class="text-center">{{ item.date }}</td>
                                <td class="text-center">{{ item.wH_Description }}</td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
        </v-col>
        <v-col cols="6">
            <v-card elevation="1" flat>
                    <v-card-title style="font-size:1rem"> سوابق خرید و فروش طلای خام</v-card-title>
                    <v-card-text>
                        <v-simple-table dir="rtl">
                            <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center">
                                        وزن (گرم)
                                    </th>
                                     <th class="text-center">
                                       قیمت طلا
                                    </th>
                                     <th class="text-center">
                                        نوع عملیات
                                    </th>
                                    <th class="text-center">
                                       مبلغ تراکنش
                                    </th>
                                    <th class="text-center">
                                        تاریخ
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                v-for="item in Model.rawGoldTransactions"
                                :key="item" 
                                >
                                <td class="text-center">{{item.r_Weight}}</td>
                                <td class="text-center">{{item.goldPrice}}</td>
                                <td class="text-center">
                                    <v-chip small dark :color="item.transactionType == 1 ? 'green':'red'">{{ item.tType }}</v-chip>
                                </td>
                                <td class="text-center">{{item.transactionPrice}}</td>
                                <td class="text-center">{{ item.date }}</td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="6">
            <v-card elevation="1" flat>
                    <v-card-title style="font-size:1rem"> سوابق درخواست تحویل فیزیکی طلا</v-card-title>
                    <v-card-text>
                        <v-simple-table dir="rtl">
                            <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center">
                                        وزن (گرم)
                                    </th>
                                    
                                    <th class="text-center">
                                      وضعیت درخواست
                                    </th>
                                    <th class="text-center">
                                        تاریخ
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                v-for="item in Model.goldDeliveries"
                                :key="item" 
                                >
                                <td class="text-center">{{item.g_Weight}}</td>
                                
                                <td class="text-center">

                                    <v-chip small v-if="item.g_Status == 0" dark color="orange">در حال بررسی</v-chip>
                                    <v-chip small v-if="item.g_Status == 1" dark color="green">تایید شد</v-chip>
                                    <v-chip small v-if="item.g_Status == 2" dark color="red">رد شد</v-chip>
                                </td>
                                <td class="text-center">{{ item.date }}</td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="6">
            <v-card elevation="1" flat>
                    <v-card-title style="font-size:1rem"> سوابق مزایده</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="TableHeaders" :items="Model.bids">
                            <template v-slot:[`item.bid`]="{ item }">
                                {{item.bid.toLocaleString("fa-IR")}} تومان
                            </template>
                            <template v-slot:[`item.auction.a_BasePrice`]="{ item }">
                                {{item.auction.a_BasePrice.toLocaleString("fa-IR")}} تومان
                            </template>
                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip small v-if="item.status == 0" color="blue accent-2" dark>در صف</v-chip>
                                <v-chip small v-if="item.status == 1" color="orange accent-2" dark>برنده نشد</v-chip>
                                <v-chip small v-if="item.status == 2" color="green accent-2" dark>برنده شد</v-chip>
                            </template>
                        </v-data-table>
                    </v-card-text>
            </v-card>
        </v-col>

    </v-row>

</template>
<script>
import JsonExcel from "vue-json-excel";
const ApiUrl = require("../../constant/apiurl");
const MSGHNDL = require("../../constant/MessageHandler");
const axios = require('axios');

export default{
    name:"detail",
    data:()=>({
        Model:{},
        TableHeaders:[
        {text:"#",value:"counter",sortable:true,align:"right"},
        {text:"عنوان مزایده",value:"auction.a_Title",sortable:true,align:"right"},
        {text:" قیمت پایه",value:"auction.a_BasePrice",sortable:true,align:"right"},
        {text:"مبلغ پیشنهادی",value:"bid",sortable:true,align:"right"},
        {text:"وضعیت ",value:"status",sortable:true,align:"right"},
        ]
    }),
    async created(){
        await this.Get();
    },
    methods:{
        filterWalletHistory(arr,type = 0)
        {
            if(typeof(arr) != undefined )
            {
                return arr.filter(x=>x.wH_CurrencyType == type);
            }
            return []
        },
        async Get()
        {
             let vm = this;
            var url=ApiUrl.UserDetaile+`/${vm.$route.params.id}`;
            
            await axios.post(url)
                .then(function (res) {
                    console.log(res);
                    if(res.data.status)
                    {
                       vm.Model = res.data.data;
                       console.warn(res.data.data);
                    }
                })
                .catch(function (error) {
                
                console.log(error);
                });
        }
    }
}
</script>
